import React, {useEffect, useState} from 'react';
import './App.css';
import useWebSocket from 'react-use-websocket';
import {
    BrowserView,
    MobileView,
    isBrowser,
} from "react-device-detect";

const WS_URL = process.env.REACT_APP_BACKEND || 'ws://localhost:8080/ws/';

// TODO Simplify this mess.
// - replace table with divs+spans
// - maybe send only pos/lines?
// - add button for creating new game
function CodeEditor({
                        lines = [],
                        currentLine = 0,
                        correctPrefix = 0,
                        currentPos = 0
                    }) {
    return (
        <div className="editor">
            <pre>
            {lines.map((line, i) => {
                if (i < currentLine) {
                    return <div key={i} className="completed">{line}</div>;
                } else if (i === currentLine) {
                    let a = line.substring(0, correctPrefix);
                    let b = line.substring(correctPrefix, currentPos);
                    let c = line.substring(currentPos, currentPos + 1);
                    let d = line.substring(currentPos + 1);
                    return <div key={i} className="current-line"><span className="green">{a}</span><span
                        className="red">{b}</span><span className="cursor">{c}</span><span>{d}</span></div>;
                } else {
                    return <div key={i}>{line}</div>;
                }
            })}
            </pre>
        </div>
    );
}

let Player = React.memo(({
                             playerName,
                             lines,
                             currentLine,
                             correctPrefix,
                             currentPos,
                             playerId,
                             gameStateState,
                             winner
                         }) => {
    return <div>
        <div className="player">
            {(gameStateState === 'over' && winner) && <>
                <div className="overlay dimmed"/>
                {winner === playerId ? <div className="overlay"><p className="greentext">WINNER</p></div> :
                    <div className="overlay"><p className="redtext"></p></div>}
            </>}
            <CodeEditor
                lines={lines}
                currentLine={currentLine}
                correctPrefix={correctPrefix}
                currentPos={currentPos}
            />
        </div>
    </div>;
});

let AwaitingContender = ({players = [], playerId, lines}) => {
    let player = players.find(player => player.id === playerId);
    return <div>
        <div className="player">
            {/*<h2>{playerName}</h2>*/}
            <div className="overlay dimmed"/>
            {!player && <div className="overlay"><p>Waiting...</p></div>}
            {player && <div className="overlay"><p>{player.name}</p></div>}
            {!player && <CodeEditor lines={['LOAD "OPPONENT",8,1', '']} currentLine={1}/>}
            {player && <CodeEditor lines={lines}/>}
        </div>
    </div>
}

let AwaitingReady = ({isReady, lines, playerState, playerName}) => {
    // console.log('Rendering player', player);
    return <div>
        <div className="player">
            {/*<h2>{playerName ? playerName.name : "unknown"}</h2>*/}
            {!isReady && <>
                <div className="overlay dimmed"/>
                <div className="overlay"><p>{playerName ? playerName.name : "unknown"}</p></div>
            </>}
            {isReady && <div className="overlay"><p>READY!</p></div>}
            <CodeEditor
                lines={lines}
                currentLine={playerState.currentLine}
                correctPrefix={playerState.correctPrefix}
                currentPos={playerState.currentPos}
            />
        </div>
    </div>
}

const Main = ({name: player}) => {
    let [players, setPlayers] = useState([]);
    let [playerId, setPlayerId] = useState();
    let [playerState, setPlayerState] = useState({
        currentPos: 0,
        currentLine: 0,
        correctPrefix: 0,
        currentText: ''
    });
    // let [lines, setLines] = useState([]);
    let [gameState, setGameState] = useState({
        events: []
    });
    let [player1Name, setPlayer1Name] = useState("unknown");
    let [player2Name, setPlayer2Name] = useState("unknown");

    console.log('BACKEND', WS_URL);
    const {sendJsonMessage, readyState} = useWebSocket(WS_URL, {
        onOpen: () => console.log('connected'),
        onMessage: evt => {
            let player1Found, player2Found;
            // let begin = performance.now();
            const message = JSON.parse(evt.data)
            // let parse = performance.now() - begin;
            // console.log(message.type, message)
            switch (message.type) {
                case 'game_state':
                    let newGameState = {
                        ...message.state
                    };
                    if (playerId === gameState.player1) {
                        newGameState.player1state = playerState;
                    } else if (playerId === gameState.player2) {
                        newGameState.player2state = playerState;
                    }
                    setGameState(newGameState);
                    setPlayer1Name(newGameState.player1name || "unknown");
                    setPlayer2Name(newGameState.player2name || "unknown");

                    if (gameState.state !== 'on') {
                        if (message.state.player1 === playerId) {
                            setPlayerState(message.state.player1state)
                        } else if (message.state.player2 === playerId) {
                            setPlayerState(message.state.player2state)
                        }
                    }
                    break;
                case 'player_id':
                    setPlayerId(message.id);
                    break;
                case 'state':
                    // console.log('State updated', message);
                    setPlayerState(message.state);
                    break;
                case 'players_updated':
                    // console.log('Players updated', message);
                    // message.players.forEach(p => {
                    //     // console.log(p)
                    //     if (p.id === playerId) {
                    //         setPlayerState(p);
                    //     }
                    // })
                    player1Found = players.find(player => player.id === gameState.player1);
                    if (player1Found) {
                        setPlayer1Name(player1Found.name);
                    }
                    player2Found = players.find(player => player.id === gameState.player2);
                    if (player2Found) {
                        setPlayer2Name(player2Found.name);
                    }
                    setPlayers(message.players);
                    break;
                // case 'lines':
                //     // console.log('new lines', message)
                //     setLines(() => message.lines.map(line => line.padEnd(60)));
                //     break;
                case 'new_game':
                    // console.log(message);
                    // history.pushState()
                    break;
                default:
                // console.log('Unknown message type:', message.type);
            }
        },
        shouldReconnect: (closeEvent) => true,
    });


    useEffect(() => {
        console.log('sending player_name');
        sendJsonMessage({
            'type': 'player_name',
            'name': player,
        })
    }, [player, sendJsonMessage])

    function textUpdated(text) {
        if (gameState.lines.length === 0) {
            return;
        }
        // console.log('text updated', text);
        let longestCommonPrefix = 0;
        let currentPos = text.length;
        // console.error(text, playerState);
        for (let i = 0; i < gameState.lines[playerState.currentLine || 0].trimEnd().length; i++) {
            let c = gameState.lines[playerState.currentLine || 0][i];
            if (c === text[i]) {
                // console.log(i);
                longestCommonPrefix = i + 1;
            } else {
                // console.log(lines[currentLine][i], e.target.value[i])
                break;
            }
        }
        let state = {
            id: playerId,
            name: player,
            currentPos: currentPos,
            currentLine: playerState.currentLine || 0,
            correctPrefix: longestCommonPrefix,
            currentText: text
        };
        setPlayerState(state);
        if (playerId === gameState.player1) {
            setGameState(gameState => {
                return {
                    ...gameState,
                    player1state: state
                }
            });
        } else if (playerId === gameState.player2) {
            setGameState(gameState => {
                return {
                    ...gameState,
                    player2state: state
                }
            });
        }
        sendJsonMessage({
            'type': 'state',
            player: player,
            "state": state
        });
    }

    function submit(form) {
        form.preventDefault();
        // console.error('submit', lines.length, playerState);
        if (typeof playerState.currentText === 'undefined') {
            return;
        }
        let text = playerState.currentText.trimEnd();
        if (text === gameState.lines[playerState.currentLine].trimEnd()) {
            let nextLine = playerState.currentLine + 1;
            let whitespace = nextLine === gameState.lines.length
                ? 0
                : gameState.lines[nextLine].search(/\S/);

            console.log(whitespace);
            if (whitespace === -1) {
                whitespace = 0;
            }
            // console.log('submit', whitespace, nextLine, lines.length, lines[nextLine], lines[nextLine].substring(0, whitespace));
            let state = {
                id: playerId,
                name: player,
                currentPos: whitespace,
                currentLine: nextLine,
                correctPrefix: whitespace,
                currentText: nextLine < gameState.lines.length ? gameState.lines[nextLine].substring(0, whitespace) : ''
            };
            setPlayerState(state);
            sendJsonMessage({
                'type': 'state',
                player: player,
                "state": state
            });
        }
    }

    function onKeyDown(e) {
        if (e.keyCode === 9) {  // tab
            e.preventDefault();
        }
    }

    function enqueue(e) {
        setPlayerState({
            currentPos: 0,
            currentLine: 0,
            correctPrefix: 0,
            currentText: ''
        });
        sendJsonMessage({'type': 'new_game'});
    }

    function join_game(e) {
        setPlayerState({
            currentPos: 0,
            currentLine: 0,
            correctPrefix: 0,
            currentText: ''
        });
        sendJsonMessage({'type': 'join_game'});
    }

    function ready(e) {
        setPlayerState({
            currentPos: 0,
            currentLine: 0,
            correctPrefix: 0,
            currentText: ''
        });
        sendJsonMessage({'type': 'player_ready'})
    }

    return <>
        {readyState !== 1 && <p>Reconnecting...</p>}
        {gameState.state === 'awaiting_contender' && <>
            <h2>1337 h4x0r coding duel</h2>
            <div className="rofl">
                <AwaitingContender players={players} lines={gameState.lines} playerId={gameState.player1}/>
                <AwaitingContender players={players} lines={gameState.lines} playerId={gameState.player2}/>
            </div>
            {!(gameState.player1 === playerId || gameState.player2 === playerId) &&
            <button onClick={join_game}>JOIN GAME!</button>}
        </>}
        {gameState.state === 'ready' && <>
            <h2>1337 h4x0r coding duel</h2>
            <div className={"rofl"}>
                <AwaitingReady
                    playerState={playerState}
                    lines={gameState.lines}
                    isReady={gameState.player1_ready}
                    playerName={players.find(player => player.id === gameState.player1)}
                />
                <AwaitingReady
                    playerState={playerState}
                    lines={gameState.lines}
                    isReady={gameState.player2_ready}
                    playerName={players.find(player => player.id === gameState.player2)}
                />
            </div>
            {((playerId === gameState.player1 && !gameState.player1_ready) || (playerId === gameState.player2 && !gameState.player2_ready)) &&
            <button onClick={ready}>READY!</button>}
            {!((playerId === gameState.player1 && !gameState.player1_ready) || (playerId === gameState.player2 && !gameState.player2_ready)) &&
            <h2>Players getting ready...</h2>}
        </>}
        {gameState.state === 'on' && <>
            <h2>{player1Name} vs {player2Name}</h2>
            <div className="rofl">
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player1state && gameState.player1state.currentLine}
                    correctPrefix={gameState.player1state && gameState.player1state.correctPrefix}
                    currentPos={gameState.player1state && gameState.player1state.currentPos}
                    playerId={gameState.player1}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player2state && gameState.player2state.currentLine}
                    correctPrefix={gameState.player2state && gameState.player2state.correctPrefix}
                    currentPos={gameState.player2state && gameState.player2state.currentPos}
                    playerId={gameState.player2}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
            </div>
            {(playerId === gameState.player1 || playerId === gameState.player2) && <>
                <form onSubmit={submit}>
                    <span className="prompt">
                        {player &&
                        <input size={40}
                               spellCheck={false}
                               autoFocus
                               type="text"
                               onChange={e => textUpdated(e.target.value)}
                               onKeyDown={onKeyDown}
                               value={playerState.currentText}
                        />}
                    </span>
                </form>
            </>}
        </>}
        {gameState.state === 'over' && <>
            <h2><em>{player1Name}</em> vs <em>{player2Name}</em></h2>
            <div className={"rofl"}>
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player1state && gameState.player1state.currentLine}
                    correctPrefix={gameState.player1state && gameState.player1state.correctPrefix}
                    currentPos={gameState.player1state && gameState.player1state.currentPos}
                    playerId={gameState.player1}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player2state && gameState.player2state.currentLine}
                    correctPrefix={gameState.player2state && gameState.player2state.correctPrefix}
                    currentPos={gameState.player2state && gameState.player2state.currentPos}
                    playerId={gameState.player2}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
            </div>
        </>}
        {gameState.state === 'init' && <>
            <h2>1337 h4x0r coding duel</h2>
            <div className={"rofl"}>
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player1state && gameState.player1state.currentLine}
                    correctPrefix={gameState.player1state && gameState.player1state.correctPrefix}
                    currentPos={gameState.player1state && gameState.player1state.currentPos}
                    playerId={gameState.player1}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
                <Player
                    lines={gameState.lines}
                    currentLine={gameState.player2state && gameState.player2state.currentLine}
                    correctPrefix={gameState.player2state && gameState.player2state.correctPrefix}
                    currentPos={gameState.player2state && gameState.player2state.currentPos}
                    playerId={gameState.player2}
                    gameStateState={gameState.state}
                    winner={gameState.winner}
                />
            </div>
        </>}

        {(gameState.state === 'init' || gameState.state === 'over') && <button onClick={enqueue}>NEW GAME</button>}
        <div className="panel">
            <div className="paneltitle">game events</div>
            <div className="panelcontent eventlog">
                {gameState.events.map(event => <div>{event}</div>)}
            </div>
        </div>
        <div className="panel">
            <div className="paneltitle">{players.length} lurker{players.length > 1 && 's'} present</div>
            <div className="panelcontent lurkers">
                {players.map(player => <span className="lurker">{player.name || "anonymous"} </span>)}
            </div>
        </div>
    </>
};

function App() {
    let name = isBrowser ? prompt("who are you?", "anonymous") : 'anonymous';
    // let name = 'anonymous';
    return (
        <>
            <BrowserView>
                <div className="App">
                    <Main name={name}/>
                </div>
            </BrowserView>
            <MobileView>
                This is a speed typing game, and it does not support mobile devices. Try again with a "real" computer!
            </MobileView>
        </>
    );
}

export default App;
